

















































































































import { Vue, Component } from 'vue-property-decorator';
import { TextInput, Uploader } from '@/components';
import { Tab, Tabs } from 'vant';
import { autoOpenApp, isWeiXin } from '@/common/ts/common';
import { getPrize, ifPrize } from './api/api';
import { FileType } from '@/common/ts/enum';
import { save } from '@/api/api';
import * as config from './config';
import { Toast } from 'vant';
Vue.use(Tab).use(Tabs);
@Component({
  components: {
    TextInput,
    Uploader,
  },
})
export default class Index extends Vue {
  active = 0;
  FileType = FileType;
  show: boolean = false;
  LoginButtonShow: boolean = true;
  pointOut: boolean = false;
  numberData = {};
  exchange: number = 0;
  name: string = '';
  chinaid = '';
  phone = '';
  weixinid: string = '';
  bangbang = '';
  option = config.OPTHINES;
  chinaidmain?: any[] = []; // 身份证照片
  chinaidopposite?: any[] = []; // 身份证照片
  correctTime: number = 0;
  prizeNum: number = 10;
  QuestionsAll: number = 250;
  ReplyAll: number = 100;
  async created() {
    // autoOpenApp();
    window.userInfoChange = () => {
      this.init();
    };
    this.init();
  }
  async init() {
    function getUnixTime(dateStr: any) {
      const newstr = dateStr.replace(/-/g, '/');
      const date = new Date(newstr);
      const TIME_STR = date.getTime().toString();
      return TIME_STR.substr(0, 10);
    }
    this.correctTime = Number(getUnixTime('2020-05-01 00:00:00'));

    const ts = Math.round(new Date().getTime() / 1000);
    // console.log( this.correctTime, ts);
    if (this.correctTime < ts) {
      // console.log('进入修改时间');
      this.prizeNum = 5;
      this.QuestionsAll = 170;
      this.ReplyAll = 150;
    }
    console.log('2020/04/30修改');
    const res = await getPrize(this.option.voteName);
    switch ((res as any).code) {
      case 200:
        this.numberData = res.data;
        this.LoginButtonShow = false;
        break;
      case 203:
        this.numberData = res.data;
        this.LoginButtonShow = true;
        break;
    }
    const exRes = await ifPrize(this.option.voteName);
    switch ((exRes as any).code) {
      case 210:
        this.exchange = 1; // 提交时间未到，条件不满足
        break;
      case 211:
        this.exchange = 2; // 提交过了
        break;
      case 200:
        this.exchange = 3; // 可以提交
        this.bangbang = exRes.data;
        break;
    }
  }
  Login() {
    if (window.udid) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
    } else if (!isWeiXin() && !window.udid) {
      window.location.href =
        'shangyounews://{"dt":"7","url":"' + location.href + '"}';
    } else if (isWeiXin()) {
      this.pointOut = true;
    }
  }
  showTable() {
    this.show = !this.show;
  }
  getOssChinaidmainImagesUrls(result: any) {
    this.chinaidmain = result[0];
  }
  getOssChinaidoppositeImagesUrls(result: any) {
    this.chinaidopposite = result[0];
  }
  async submit() {
    if (this.name && this.chinaid && this.phone && this.weixinid) {
      const data = {
        name: this.name,
        chinaid: this.chinaid,
        phone: this.phone,
        weixinid: this.weixinid,
        bangbang: this.bangbang,
        chinaidfront: this.chinaidmain,
        chinaidreverse: this.chinaidopposite,
      };
      const res = await save(this.option.voteName, data);
      if ((res as any).code === 200) {
        Toast.success((res as any).msg);
        this.show = false;
        this.init();
      } else {
        Toast((res as any).msg);
      }
    } else {
      Toast.fail('填写完整信息');
    }
  }
}
